<template>
  <div class="container">
    <div class="notification is-dvodark">
      <div class="columns is-centered">
        <div class="column has-text-centered">
          <h1 class="is-size-3">
            WARRANTY REQUEST FORM
          </h1>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <p class="required is-size-7 is-italic">
            Fields marked with a <span class="custom-dvocolor">*</span> are required
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column is-two-thirds">
          <div class="columns">
            <div class="column">
             <!-- <p>{{warrantyArray}}</p> -->
              <b-field horizontal label="Company Representing (*)">
                  <b-select expanded v-model="selectedCompany" required>
                      <option class="has-text-white is-bold" selected="selected">
                      </option>
                      <option class="has-text-white" v-for="option in userCompany" :value="option"
                          :key="option.id">
                          {{ option.name }}
                      </option>
                  </b-select>
              </b-field>
            </div>
          </div>
          <div class="columns has-background-dvoalt">
            <div class="column">
              <b-field horizontal label="Reference Number">
                <b-input v-model="referenceNumber"></b-input>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <b-field horizontal label="Serial Number (*)">
                  <b-autocomplete
                        v-model="itemTyped"
                        placeholder="DV1000000000"
                        :open-on-focus="false"
                        :data="itemsList"
                        @keyup.native="getItems()"
                        @select="function (option) {
                          (itemToBeRepaired = option)
                          handleItemChange()
                        }"
                        @change="handleItemChange()"
                        field="serial"
                        :clearable="true"
                    >
                  <template #empty>No results found</template>  
                </b-autocomplete>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <b-field horizontal label="Date Of Purchase">
                <span v-if="selectedItem" class="tag is-large is-warning">
                        {{ new Date(selectedItem.date_purchase).toLocaleDateString() }}
                </span>
                  <p v-else>MM/DD/YYYY</p>
              </b-field>
              <b-field  v-if="selectedItem" horizontal label="Description of Product">
                <span>
                    {{ selectedItem.description }}
                </span>
              </b-field>
              <b-field  v-if="selectedItem" horizontal label="Owner">
                <span v-if="computedFirstLast">
                    {{ selectedItem.first_name }} {{selectedItem.last_name}}
                </span>
                <span v-else> USER NAME NOT FOUND. EMAIL : {{selectedItem.email }}</span>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <b-field horizontal label="Add Service Code/Parts" grouped>
                <!-- <b-button class="is-dvogreen" size="is-large" @click="addCodeParts()"> Add Service Codes and Parts </b-button> -->
              </b-field>
                <b-field horizontal label="Add Parts">
                <b-button class="is-dvogreen" size="is-large" @click="addMisc()"> Add Parts </b-button>
              </b-field>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-centered has-text-centered">
        <div class="column is-half">
          <b-field horizontal label="Comment">
            <b-input type="textarea" v-model="comment"></b-input>
          </b-field>
        </div>
      </div>
      <div class="columns is-centered">
        <div class="column has-text-centered">
          <h1 class="is-size-3">
            ITEMS USED FOR REPAIR
          </h1>
        </div>
      </div>
      <div class="columns is-centered">
        <div class="column is-green-border">
          <div class="columns">
            <div class="column is-1">
              <p class="is-bigger">Service Code</p>
            </div>
            <div class="column is-2">
              <p class="is-bigger">Part Number</p>
            </div>
            <div class="column is-2">
              <p class="is-bigger">Quantity</p>
            </div>
            <div class="column is-3">
              <p class="is-bigger">Description</p>
            </div>
            <div class="column is-2">
              <p class="is-bigger">Price</p>
            </div>
            <div class="column is-2">
              <p class="is-bigger">Total Price</p>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-centered" v-for="(warranty, parent_node_index) in warrantyArray" :key="parent_node_index">
        <div class="column" >
          <div class="columns" v-for="(part, index) in warranty.parts" :key="index">
            <div class="column is-1">
              {{warranty.service_code}}
            </div>
            <div class="column is-2">
              <p>{{ part.number }}</p>
            </div>
            <div class="column is-2">
              <p>{{part.quantity}}</p>
            </div>
            <div class="column is-3">
              <p>{{part.description}}</p>
            </div>
            <div class="column is-2">
              <p>{{part.distributor_cost}}</p>
            </div>
            <div class="column is-1">
              <p>$ {{  (part.quantity * part.distributor_cost ).toFixed(2) }}</p>
            </div>
            <div class="column is-1">
              <b-button class="is-danger" @click="removePart(warrantyArray, parent_node_index)"><i class="far fa-trash-alt"></i></b-button>
            </div>
          </div>
        </div>
      </div>
      <section class="section">
      <div class="columns is-centered padding-custom">
        <div class="column is-half is-offset-half">
          <div class="columns has-background-dvolightgrey">
            <div class="column is-half has-text-right">
              <p class="is-bigger">Parts Sub Total: </p>
            </div>
            <div class="column is-half has-text-right">
              <p>$ {{ computedSubTotal }}</p>
            </div>
          </div>
          <div class="columns">
            <div class="column is-half has-text-right">
              <p class="is-bigger">Landed %: </p>
            </div>
            <div class="column is-half has-text-right">
              <p v-if="selectedCompany"> ${{computedLanding}} ({{ selectedCompany.landing_percent}}%)</p>
              <p v-else>SELECT COMPANY FOR PRICE</p>
            </div>
          </div>
          <div class="columns">
            <div class="column is-half has-text-right">
              <p class="is-bigger">Labor Rate: </p>
            </div>
            <div class="column is-half has-text-right">
              <p v-if="selectedCompany">{{ selectedCompany.labor_cost}}</p>
              <p v-else>SELECT COMPANY FOR PRICE</p>
            </div>
          </div>
          <div class="columns">
            <div class="column is-half has-text-right">
              <p class="is-bigger">Oil ($): </p>
            </div>
            <div class="column is-half has-text-right">
              <b-numberinput :controls="false" v-model="oil"></b-numberinput>
            </div>
          </div>
          <div class="columns">
            <div class="column is-half has-text-right">
              <p class="is-bigger">Freight ($): </p>
            </div>
            <div class="column is-half has-text-right">
              <b-numberinput :controls="false" v-model="freight"></b-numberinput>
            </div>
          </div>
          <div class="columns">
            <div class="column is-half has-text-right">
              <p class="is-bigger">Total Credit: </p>
            </div>
            <div class="column is-half has-text-right">
              <p>$ {{computedTotal}}</p>
            </div>
          </div>
          <div class="columns">
            <div class="column is-half is-offset-half has-text-right">
              <button class="button is-medium is-dvogreen" @click="submitWarranty()">Submit</button>
            </div>
          </div>
        </div>
      </div>
      </section>
    </div>
  </div>
</template>

<script>
import { API } from 'aws-amplify';
import Auth from "@aws-amplify/auth";
import { personHandler, companyFromPersonCompanyRoleHandler, warrantyHandler, warrantyServicePartHandler } from '../graphql/mutations'
import { getItemWithProduct, getItemsWithProduct, getDailyCount } from '../graphql/queries'
import AddCodeParts from './AddCodeParts';
import AddMisc from './AddMisc'
import ItemPersonNotFound from './ItemPersonNotFound'
import ItemDateNotFound from './ItemDateNotFound'
import ItemPersonDateNotFound from './ItemPersonDateNotFound'

export default {
  data() {
      return {
        selectedCompany: null,
        user_id: null,
        userCompany: [],
        primaryContact: null,
        referenceNumber: null,
        submitted: new Date(),
        comment: null,
        itemTyped: null,
        itemToBeRepaired: null,
        itemsList: [],
        select: null,
        oil: 0,
        freight: 0,
        warrantyArray: [],
        warrantyId: null,
        selectedItem: null,
        dateFound: false
      }
    },
    computed: {
      computedDateOfPurchase: function(){
        if(this.selectedItem.date_purchase != null){
          return true
        } else {
          return false
        }
      },
      computedIsPersonForItem: function(){
        if(this.selectedItem.person_id != null){
          return true
        } else {
          return false
        }
      },
      computedFirstLast: function(){
        if(this.selectedItem.first_name && this.selectedItem.last_name){
          return true
        } else {
          return false
        }
      },
      computedLanding:function(){
        if(this.selectedCompany && this.computedSubTotal){
          return Number(this.computedSubTotal * (this.selectedCompany.landing_percent * 0.01)).toFixed(2)
        } else {
          return 0
        }
      },
      computedSubTotal: function(){
        let total = 0
        for (let i = 0; i < this.warrantyArray.length; i++) {
          for (let j = 0, len = this.warrantyArray[i].parts.length; j < len; j++) {
            total += (this.warrantyArray[i].parts[j].quantity * this.warrantyArray[i].parts[j].distributor_cost) 
          } 
        }
        return (Number(total)).toFixed(2)
      },
      computedTotal: function(){
        let total = 0
        for (let i = 0, len = this.warrantyArray.length; i < len; i++) {
          for (let j = 0, len = this.warrantyArray[i].parts.length; j < len; j++) {
            total += (this.warrantyArray[i].parts[j].quantity * this.warrantyArray[i].parts[j].distributor_cost) 
          } 
        }
        if (this.selectedCompany && this.selectedCompany.landing_percent && this.selectedCompany.labor_cost){
          return total =  Number(total * (1 + this.selectedCompany.landing_percent * 0.01) + this.selectedCompany.labor_cost + this.oil + this.freight).toFixed(2)
        }
        return total + this.oil + this.freight
      },
    },
    methods: {
      doAThing(event, parentIndex, childIndex){
          console.log(this.warrantyArray[parentIndex].parts[childIndex])
          let whatWas = this.warrantyArray[parentIndex].parts[childIndex]
          console.log(whatWas)
          whatWas.parts[childIndex].quantity = event
          this.warrantyArray[parentIndex].parts.splice(childIndex, 1)
          // this.warrantyArray[parentIndex].parts[childIndex] = whatWas
      },
      async getItems(){
          const temp = await API.graphql({
          query: getItemsWithProduct,
          variables: {
            input: {
              request_type: 'read_with_input',
              entered: this.itemTyped
            }
          }
        });
        this.itemsList = temp.data.getItemsWithProduct;
      },
      async handleItemChange(input){

        if(input){

          const item = await API.graphql({
              query: getItemWithProduct,
              variables: {
                input: {
                  request_type: 'read_one_with_product',
                  serial: input.serial
                }
              }
            });

          this.selectedItem = item.data.getItemWithProduct
              if(this.selectedItem === null){
                  return
              } else if(!this.computedIsPersonForItem && !this.computedDateOfPurchase){
                this.itemPersonDateNotFound(this.selectedItem.serial)
                return
              } else if(!this.computedIsPersonForItem){
                this.itemPersonNotFound(this.selectedItem.serial)
              } else if(!this.computedDateOfPurchase){
                this.itemDateNotFound(this.selectedItem.serial);
                return
              } else {
                return
              }
        } else {
            const item = await API.graphql({
              query: getItemWithProduct,
              variables: {
                input: {
                  request_type: 'read_one_with_product',
                  serial: this.itemToBeRepaired.serial
                }
              }
            });

            this.selectedItem = item.data.getItemWithProduct;

            if(this.selectedItem === null){
                return
            } else if(!this.computedIsPersonForItem && !this.computedDateOfPurchase){
              this.itemPersonDateNotFound(this.selectedItem.serial)
              return
            } else if(!this.computedIsPersonForItem){
              this.itemPersonNotFound(this.selectedItem.serial)
            } else if(!this.computedDateOfPurchase){
              this.itemDateNotFound(this.selectedItem.serial);
              return
            } else {
              return
            }
        }

      },     
      rowTotalPrice: function(number, price) {
        console.log(number)
        console.log(price)
        return Number(number * price)
      },
      formatDate(date) {
          var d = new Date(date),
              month = '' + (d.getMonth() + 1),
              day = '' + d.getDate(),
              year = d.getFullYear();

          if (month.length < 2) 
              month = '0' + month;
          if (day.length < 2) 
              day = '0' + day;

          return [year, month, day].join('-');
      },
      async getDate(){
        const date = new Date();
        const today = this.formatDate(date)
        const countHolder = await API.graphql({
          query: getDailyCount,
          variables: {
            input: {
              submitted: today,
              request_type:'get_daily_count'
            }
          }
        });
        let daily = countHolder.data.getDailyCount.daily
        switch (daily.length) {
              case 0:
                daily = '0001'
                break;
              case 1:
                daily = '000' + daily
                break;
              case 2:
                daily = '00' + daily
                break;
              case 3:
                daily = '0' + daily
                break;
        }
        return today + '-' + daily
      },
      async getUserInfo() {
        const cognitoUser = await Auth.currentAuthenticatedUser();
        const userInput = {
          cognito_id: cognitoUser.attributes.sub,
          request_type: 'read_by_cognito_id'
        };
        const dvoUser = await API.graphql({
          query: personHandler,
          variables: {
            input: userInput
          }
        });
        this.user_id = dvoUser.data.personHandler.id
        const tempUserCompany = await API.graphql({
          query: companyFromPersonCompanyRoleHandler,
          variables: {
            input: {
              request_type: 'find_company_by_user',
              user_id: this.user_id
            }
          }
        });
        const holder = tempUserCompany.data.companyFromPersonCompanyRoleHandler
            let seenId = []
            for (let i = 0; i < holder.length; i++){
                if (seenId.includes(holder[i].company_id)){
                  continue;
                } else {
                    seenId.push(holder[i].company_id)
                    this.userCompany.push(holder[i])
                }
            }
      },
      addCodeParts() {
        this.$buefy.modal.open({
          parent: this,
          component: AddCodeParts,
          hasModalCard: true,
          trapFocus: true,
          events: {
            'pass-warranty-obj': value => {
              var normalized = value.parts.filter(function filterParts(part) {
                return part.number != null && (typeof part.quantity === 'number') && part.quantity > 0;
              });
              value.parts = normalized;
              this.warrantyArray.push(value)
            }
          }
        })
      },
      itemPersonDateNotFound(serial){
        this.$buefy.modal.open({
          parent: this,
          component: ItemPersonDateNotFound,
          hasModalCard: true,
          canCancel: false,
          trapFocus: true,
          props: {
            initSerial: serial
          },
          events:{
            'onSubmit': value => {
              this.handleItemChange(value)
            },
            'onCancel': () => {
              this.itemTyped = null;
              this.itemToBeRepaired = null;
              this.selectedItem = null;
            },
          }
        })
      },
      itemPersonNotFound(serial) {
        this.$buefy.modal.open({
          parent: this,
          component: ItemPersonNotFound,
          hasModalCard: true,
          canCancel: false,
          trapFocus: true,
          fullScreen: false,
          props: {
            initSerial: serial
          },
          events:{
            'onCancel': () => {
              this.itemTyped = null;
              this.itemToBeRepaired = null;
              this.selectedItem = null;
            },
            'onSubmit': () => {
              this.handleItemChange(this.selectedItem.serial)
            }
          }
        })
      },
      itemDateNotFound(serial) {
        this.$buefy.modal.open({
          parent: this,
          component: ItemDateNotFound,
          hasModalCard: false,
          canCancel: false,
          trapFocus: true,
          fullScreen: true,
          props: {
            initSerial: serial
          },
          events:{
            'onCancel': () => {
              this.itemTyped = null;
              this.itemToBeRepaired = null;
              this.selectedItem = null;
            },
            'onSubmit': () => {
              this.handleItemChange(this.selectedItem.serial)
            }
          }
        })
      },
      addMisc() {
        this.$buefy.modal.open({
          parent: this,
          component: AddMisc,
          hasModalCard: true,
          trapFocus: true,
          events: {
            'pass-warranty-obj': value => {
              var normalized = value.parts.filter(function filterParts(part) {
                return part.number != null && (typeof part.quantity === 'number') && part.quantity > 0;
              });
              value.parts = normalized;
              this.warrantyArray.push(value)
            }
          }
        })
      },
      removePart(inputArray, index){
            inputArray.splice(index, 1)
      },
      addIds(param){
          for (let i = 0, len = this.warrantyArray.length; i < len; i++) {
            this.warrantyArray[i].warranty_id = param
          }
      },
      async submitPivot(){
          for (let i = 0, len = this.warrantyArray.length; i < len; i++) {
            for (let j = 0, length = this.warrantyArray[i].parts.length; j < length; j++) {
                await API.graphql({
                  query: warrantyServicePartHandler,
                  variables: {
                    input: {
                      request_type: 'add',
                      service_code: this.warrantyArray[i].service_code,
                      warranty_id: this.warrantyArray[i].warranty_id,
                      part_number: this.warrantyArray[i].parts[j].number,
                      price: this.warrantyArray[i].parts[j].distributor_cost,
                      qty: Number(this.warrantyArray[i].parts[j].quantity)
                    }
                  }
                });
            }
        }
      },
      async submitWarranty() {

        if(!this.referenceNumber){
          this.referenceNumber = ""
        }

        if( ((this.oil || this.freight ) === null )|| ((this.oil || this.freight) === undefined )) {
                this.$buefy.notification.open({
                    duration: 5000,
                    message: `You cannot submit a warranty without a price for oil and freight`,
                    position: 'is-bottom',
                    type: 'is-danger',
                    hasIcon: true
                })
        }  else if (this.selectedCompany === undefined || this.selectedCompany === null) {
                this.$buefy.notification.open({ 
                    duration: 5000,
                    message: `You cannot submit a warranty without a company, if your company is not regstered please submit a request via the account page`,
                    position: 'is-bottom',
                    type: 'is-danger',
                    hasIcon: true
                })
        } else if (this.itemToBeRepaired === null){
                    this.$buefy.notification.open({
                    duration: 5000,
                    message: `You cannot submit a warranty without an item`,
                    position: 'is-bottom',
                    type: 'is-danger',
                    hasIcon: true
                })

        } else {
        const theId = await this.getDate()
        const submitted = this.submitted.getFullYear() + "/" + (this.submitted.getMonth() + 1) + "/" + this.submitted.getDate();
        const warrantyHolder = await API.graphql({
          query: warrantyHandler,
          variables: {
            input: {
              request_type: 'create',
              id: theId,
              serial_id: this.itemToBeRepaired.serial,
              company_id: this.selectedCompany.company_id,
              reference_number: this.referenceNumber,
              oil_cost: this.oil,
              freight: this.freight,
              comment: this.comment,
              contact_number: this.primaryContact,
              submitted: submitted,
              total: this.computedTotal,
              instance_landing: this.selectedCompany.landing_percent,
              instance_labor: this.selectedCompany.labor_cost
            }
          }
        });
        this.warrantyId = warrantyHolder.data.warrantyHandler.id
         let myFancyParam = theId
         await this.addIds(myFancyParam);
        this.submitPivot();
        this.$router.push({
        name: 'WarrantyCreditRequest'
        })
        }
      }
    },
    async mounted() {
      this.getItems();
      this.getUserInfo();
    }
  }
</script>

<style lang="scss">

.padding-custom{
  padding-right: 5rem;
}

.is-bigger{
  font-size: 0.8em;
  font-family: 'Roboto', sans-serif;
  font-weight: 900; 
}
  .field-label .label {
    color: #82bc00 !important;
    font-size: 0.8em;
    font-family: 'Roboto', sans-serif;
    font-weight: 900;
}  

.required{
  font-family: 'Roboto', sans-serif;
  font-weight: 100;
  font-style: italic;
}

.custom-dvocolor{
  color: #82bc00;
}

.is-green-border{
  border: 1px solid #82bc00;
}

.textarea {
  background-color : transparent; 
  color: white;
}

.select{
  background-color : transparent; 
  color: white;
}

input[type="text"], textarea {
  background-color : transparent; 
  color: white;
}

h1 {
  font-family: 'Anton', sans-serif;
}

p {
  font-family: 'Roboto', sans-serif;
  font-weight: 100;
}
</style>